import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import {t} from 'shared/core';

class PublicInterviewSchedule extends DomainObject {
  calendarEventName;
  duration;
  location;
  address;
  phoneNumber;
  eventDescription;
  videoConferencingProvider;
  interviewers;

  constructor(other) {
    super();

    makeObservable(this, {
      calendarEventName: observable,
      duration: observable,
      location: observable,
      address: observable,
      phoneNumber: observable,
      eventDescription: observable,
      videoConferencingProvider: observable,
      interviewers: observable,
      locationView: computed
    });

    this.merge(other);
  }

  get locationView() {
    if (this.videoConferencingProvider) {
      return t(`recruiting.schedule_interview.location.video_conferencing_provider.${this.videoConferencingProvider}`);
    }

    return t(`recruiting.schedule_interview.location.${this.location}`);
  }
}

export default PublicInterviewSchedule;
